module.exports = __webpack_public_path__ + "img/industryScore2.2b65ad72.png";